import { baseApi } from '@/services'
import { TitleReportMetadata } from '@/types/unlock'

export const documentMetadataApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLatestTitleReportMetadata: builder.query<TitleReportMetadata, string | string[]>({
      query: (applicationUUID) =>
        `v2/applications/${applicationUUID}/title-report-metadata/latest/`,
    }),
  }),
})

export const { useGetLatestTitleReportMetadataQuery } = documentMetadataApi
